import PropTypes from 'prop-types'
import React from 'react'
import { INSTANT_LITERALS, LITERAL_TYPES, NUMBER_SUFFIX_SPACER } from './literalUtility'
import Input from '../Input/Input'
import { Input as Combobox } from '../Combobox'
import Field from '../Field'
import moment from 'moment-timezone'
import { WEEKDAYS, isTodayCheck } from '../../../utility'

const DEFAULT_NUMBER = 1
const STYLE = {
  width: '17rem',
  padding: '.5rem'
}

export default class Literal extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string, // Literal
      PropTypes.number // Timestamp
    ]),
    onChange: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    menuIsOpen: false
  }

  constructor (props) {
    super(props)
    this.state = {
      value: props.value,
      isNumberSuffix: this.parseIsNumberSuffix(props.value),
      numberSuffix: DEFAULT_NUMBER,
      instantLiterals: {},
      activeInstantLiteral: ''
    }
  }
  onLiteralChange = (v) => {
    if (v !== null) {
      let value = v
      if (this.parseIsNumberSuffix(value)) {
        value += DEFAULT_NUMBER
      }
      this.setState({
        value,
        isNumberSuffix: this.parseIsNumberSuffix(value.value)
      })
      this.props.onChange(value.value, true)
      this.props.onClose && this.props.onClose()
      this.setState({
        menuIsOpen: false
      })
    } else {
      this.setState({ value: null })
    }
  }
  menuOpen = () => {
    this.setState({ menuIsOpen: true })
    this.props.onOpen()
  }
  parseIsNumberSuffix = (val) => {
    if (val && typeof val === 'string') {
      return val.includes(NUMBER_SUFFIX_SPACER)
    }
    return false
  }
  onSuffixChange = (value) => {
    const { onChange } = this.props
    const newValue = `${this.state.value.value}`
    this.setState({
      numberSuffix: value
    })
    if (this.parseIsNumberSuffix(newValue)) {
      let results = newValue.split(NUMBER_SUFFIX_SPACER)
      results[1] = value
      const newValue2 = results.join(NUMBER_SUFFIX_SPACER)
      onChange && onChange(newValue2, true)
      // this.setState({ value: newValue2, isNumberSuffix: true })
    }
  }

  setInstantLiteralAdditional = (name, value) => {
    this.setState((state, props) => ({
      instantLiterals: {
        ...state.instantLiterals,
        [name]: value
      },
      ...(name === state.activeInstantLiteral) && { activeInstantLiteral: '' }
    }))

  }

  setActiveInstantLiteral = (name) => {
    this.setState((state, props) => ({
      activeInstantLiteral: name
    }))
    this.handleInstantLiteralSelect(name)
  }

  handleInstantLiteralSelect = (name) => {
    const { handleClose, onChange } = this.props
    const { instantLiterals } = this.state
    let selectedDate = new Date()

    switch (name) {
      case 'YESTERDAY':
        selectedDate = new Date(selectedDate.getTime() - (24 * 60 * 60 * 1000))
        break
      case 'TOMORROW':
        selectedDate = new Date(selectedDate.getTime() + (24 * 60 * 60 * 1000))
        break
      case 'IN':
        const daysNumber = parseInt(instantLiterals['IN'], 10) || 2
        selectedDate = new Date(selectedDate.getTime() + (daysNumber * 24 * 60 * 60 * 1000))
        break
      case 'NEXT':
        const day = instantLiterals['NEXT'] || 'Monday'
        const idx = WEEKDAYS.indexOf(day)
        const dayIndex = idx !== -1 ? idx + 1 : 1
        selectedDate.setDate(selectedDate.getDate() + (((dayIndex + 7 - selectedDate.getDay()) % 7) || 7))
        break
    }
    const momentValue = moment(selectedDate)
    const isToday = isTodayCheck(momentValue.toDate())
    const today = new Date()
    const currentHour = today.getHours()

    momentValue.set({
      hour: isToday ? currentHour + 1 : 9,
      minute: 0,
      second: 0,
      millisecond: 0
    })
    onChange(momentValue)
    this.setState({
      menuIsOpen: false
    })
    if (handleClose && typeof handleClose === 'function') {
      handleClose()
    }
  }

  render () {
    const { isInstant } = this.props
    const { value, isNumberSuffix, instantLiterals } = this.state
    let numberSuffix = this.state.numberSuffix
    const literalList = isInstant
      ? INSTANT_LITERALS
      : LITERAL_TYPES.map(v => ({ value: v, label: v.replace(':', '') }))
    // let literalValue = null
    if (value && typeof value === 'string') {
      if (this.parseIsNumberSuffix(value)) {
        // value has number suffix
        let splittedValue = value.split(NUMBER_SUFFIX_SPACER)
        if (LITERAL_TYPES.find(el => el.includes(splittedValue[0]))) {
          // const baseValue = `${splittedValue[0]}:`
          // literalValue = { value: baseValue, label: baseValue.replace(':', '') }
          numberSuffix = splittedValue[1]
        }
      } else {
        // value is exactly like literal (no additional suffix)
        // const litFounded = LITERAL_TYPES.find(el => el.includes(value))
        // if (litFounded && litFounded === value) {
        //   literalValue = { value: value, label: value }
        // }
      }
    }

    return (
      <div style={STYLE}>
        {
          !isInstant
            ? <>
              <Combobox
                menuIsOpen={this.state.menuIsOpen}
                onMenuOpen={() => { this.menuOpen() }}
                options={literalList}
                value={value}
                onChange={this.onLiteralChange}
                menuPlacement={'top'}
                blurInputOnSelect
              />
              {
                isNumberSuffix
                  ? <Input type='number' min={1} value={numberSuffix} label='Number' onChange={this.onSuffixChange} />
                  : null
              }
            </>
            :
            <>
              {
                literalList.map(item => {
                  const { name, type, picklist, defaultValue, afterWords } = item
                  return (
                    <div className={'p-2 flex space-x-2 items-center'}>
                      <div>
                        {name}
                      </div>
                      {
                        type &&
                        <div className={'w-50'}>
                          <Field
                            type={type}
                            { ...picklist && { picklist } }
                            onValueChange={(v) => this.setInstantLiteralAdditional(name, v)}
                            value={instantLiterals[name] || defaultValue}
                          />
                        </div>
                      }
                      {
                        afterWords &&
                        <div>
                          {afterWords}
                        </div>
                      }
                      <div className={'ml-auto'}>
                        <div
                          className={'cursor-pointer'}
                          style={{
                            fontSize: '.5rem',
                            fontWeight: 'bold'
                          }}
                          onClick={() => this.setActiveInstantLiteral(name)}
                        >
                          APPLY
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </>

        }
      </div>
    )
  }
}
